import './Home.css';
import React, {useState} from 'react';
import { useNavigate } from "react-router-dom";
import LandingPageImage from '../../assets/landing-page.png'
import Header from '../common/Header';

const Home = () => {
	const navigate = useNavigate()
	const [linkId, setLinkId] = useState("")
	const onLinkChange = (e) => {
		setLinkId(e.target.value)
	}

	const redirectToCreateSession = () => {
		navigate('/create-session')
	}

	const redirectToPrecall = () => {
		let link = linkId.split("/");
		link = link[link.length-1]
		navigate(`/precall/${link}`)
	}

	return (
		<div className="homepage-lp">
			<Header />
			<div className="form-container-lp">
				<h1>Elevating the quality of your class</h1>
				<p>Shape a comprehensive discussion activity begins now.</p>
				<div className="form-detail">
					<button 
						onClick={redirectToCreateSession}
						className='wiyata-btn'
						>
						Create
					</button>
					<p className='or'>or</p>
					<input
						className="wiyata-text-input"
						type="text" 
						name="link-id" 
						placeholder="Enter link"
						value={linkId}
						onChange={onLinkChange}
						required
					/>
					{
						linkId.length !== 0 &&
						<button 
							onClick={redirectToPrecall}
							className='wiyata-btn join-lp'
						>Join</button>
					}
				</div>
			</div>
			<div className="img-lp">
				<img src={LandingPageImage} alt="" className='img-lp-item' />
			</div>
		</div>
	);
}
 
export default Home;